<button
        type="button"
        #trigger
        class="btn btn-link p-0 lh-1 text-decoration-none chatbot-trigger"
        [tooltip]="'Ask AI' | translate"
        placement="left"
        boundariesElement="viewport"
        containerClass="me-3"
        (click)="onChatbotClick()"
>
    <i class="fa-solid fa-user-astronaut"></i>
</button>

@defer (when popupRequested) {
    <app-chatbot-popup
            [origin]="trigger"
            [openRequest]="openRequest"
    ></app-chatbot-popup>
}
